<template>
  <Modal 
    :value="show" 
    class="coupon-modal" 
    :mask-closable="false" 
    :footer-hide="true" 
    :header-hide="true" 
    @on-visible-change="handleVisbleChange">
    <div class="coupon-inner">
      <img src="../images/coupon-modal-bg.png" alt="优惠券">
      <div class="coupon-content">
        <h3>优惠券</h3>
        <div class="coupon-price">
          <span class="price-unit">￥</span>
          <span class="price-value">{{ coupon.totalMoney | numeral }}</span>
        </div>
        <button class="makeOrder-btn" @click="handleGo">立即下单</button>
        <div class="coupon-desc">
            <div class="coupo-desc__left">
              <p>单张面额：{{coupon.value}}元</p>
              <p>此次发放：{{coupon.totalNum}}张</p>
              <p>有效期：{{ coupon.beginTime | dateFmt }}-{{ coupon.endTime | dateFmt }}</p>
            </div>
            <div class="coupo-desc__right">最终解释权归鸭嘴兽所有</div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from "vuex"
import numeral from "numeral"
import dayjs from "dayjs"
import Cookies from "js-cookie"
export default {
  props: {
    
  },
  computed: {
    ...mapState('coupon', {
      show: "showCouponModal",
      coupon: "latestCoupon"
    })
  },
  data() {
    return {
      // show: false
    }
  },
  methods: {
    handleVisbleChange(show) {
      // console.log(show)
      this.$store.commit("coupon/toggleCouponModal", show)
      if (!show) {
        Cookies.set("COUPON_READ", this.coupon.templateId, {expires: 1})
      }
    },
    handleGo() {
      this.$router.push("/place-order/index")
      this.$store.commit("coupon/toggleCouponModal", false)
    }
  },
  filters: {
    numeral(number) {
      return numeral(number).format("0,0")
    },
    dateFmt(date, pattern = "YYYY/MM/DD") {
      return dayjs(date).format(pattern)
    }
  }
}
</script>

<style lang="less">
.coupon-modal .ivu-modal-content {
  background-color: transparent;
  .coupon-inner {
    position: relative;
    img {
      width: 100%;
    }
    .coupon-content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      color: #fff;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      h3 {
        font-size: 30px;
        font-weight: 700;
      }
      .coupon-price {
        margin: 50px 0;
        color: #fdf18b;
        font-weight: 700;
        .price-unit {
          font-size: 36px;
        }
        .price-value {
          font-size: 60px;
        }
      }
      .makeOrder-btn {
        display: inline-block;
        background: #fdf18b;
        border: none;
        color: #77bccb;
        font-size: 20px;
        font-weight: 700;
        padding: 6px 10px;
        border-radius: 4px;
        letter-spacing: 2px;
        z-index: 9;
        cursor: pointer;
        &:focus {
          border: none;
        }
      }
      .coupon-desc {
        position: absolute;
        bottom: 0;
        width: 100%;
        box-sizing: border-box;
        padding: 15px;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;   
        text-align: left;
      }
    }
  }
  .ivu-modal-close {
    right: -10px;
    top: 0px;
    i {
      color: #fff;
      font-weight: bold;
      font-size: 40px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// coupon-modal.vue?561ccaf2